var _path, _path2, _circle, _path3, _path4, _circle2, _path5, _path6, _path7, _path8, _circle3, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCsyBody(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 31,
    viewBox: "0 0 45 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.86471 12.6219C2.89319 10.9586 11.6936 13.0005 16.6438 14.4403C16.8564 14.5021 17 14.6967 17 14.9182V17.9345C17 18.1929 16.7963 18.4094 16.539 18.4326C4.40542 19.5288 1.67687 18.9061 1.34275 17.675C0.820903 15.7521 0.820965 14.3099 1.86471 12.6219Z",
    fill: "#FECE61",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99995 13.4999C3.44607 12.7244 11.473 14.284 15.151 15.392C15.3595 15.4548 15.5 15.6479 15.5 15.8656V16.547C15.5 16.8041 15.3013 17.0197 15.0455 17.0447C6.39833 17.8906 2.73823 17.9436 2.5 17C2.12614 15.5191 2.25216 14.7998 2.99995 13.4999Z",
    fill: "#FF5763",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 15.5,
    r: 1,
    fill: "#FECE61",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1353 12.6219C42.1068 10.9586 33.3064 13.0005 28.3562 14.4403C28.1436 14.5021 28 14.6967 28 14.9182V17.9345C28 18.1929 28.2037 18.4094 28.461 18.4326C40.5946 19.5288 43.3231 18.9061 43.6572 17.675C44.1791 15.7521 44.179 14.3099 43.1353 12.6219Z",
    fill: "#FECE61",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0001 13.4999C41.5539 12.7244 33.527 14.284 29.849 15.392C29.6405 15.4548 29.5 15.6479 29.5 15.8656V16.547C29.5 16.8041 29.6987 17.0197 29.9545 17.0447C38.6017 17.8906 42.2618 17.9436 42.5 17C42.8739 15.5191 42.7478 14.7998 42.0001 13.4999Z",
    fill: "#FF5763",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 39.5 15.5)",
    fill: "#FECE61",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.034 16.4715C10.4219 14.1435 12.0958 15.0773 12.9565 15.896C13.0082 15.9452 13.0469 16.0061 13.072 16.0729L14.2515 19.2184C14.3816 19.5654 14.1031 19.9237 13.7397 19.8513C12.0183 19.5086 9.69104 18.529 10.034 16.4715Z",
    fill: "#FFE2DF",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 16.4715C34.112 14.1435 32.4381 15.0773 31.5775 15.896C31.5258 15.9452 31.487 16.0061 31.462 16.0729L30.2824 19.2184C30.1523 19.5654 30.4308 19.9237 30.7943 19.8513C32.5156 19.5086 34.8429 18.529 34.5 16.4715Z",
    fill: "#FFE2DF",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6349 20C22.8349 20 16.8016 21 14.6349 21.5C12.9317 23.2032 10.3726 26.237 8 30H37.1349C34.557 25.4356 31.7502 21.8509 29.6349 20Z",
    fill: "#FF5763",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.163 21C22.1823 21 16.8759 21.9 14.9703 22.35C13.4724 23.8829 11.2216 26.6133 9.13489 30H36.1349C33.8676 25.8921 30.0234 22.6658 28.163 21Z",
    fill: "#FF5763",
    stroke: "#FF5763",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.1349,
    cy: 19,
    r: 9.5,
    fill: "#FFE2DF",
    stroke: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0109 1C15.9502 1 13.0949 8.59962 13.0023 13.1242C12.9944 13.5114 13.4268 13.7227 13.7526 13.5135C19.472 9.84241 24.4915 9.82888 30.2055 13.4729C30.5451 13.6895 30.9931 13.4528 30.964 13.051C30.636 8.5182 28.039 1 22.0109 1Z",
    fill: "#E73943",
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0109 7C16.0769 7 13.2157 10.9228 13.0118 13.3735C12.9851 13.694 13.3096 13.893 13.6132 13.7866C19.4298 11.7478 24.5138 11.7379 30.3231 13.7568C30.6521 13.8712 30.9935 13.6283 30.932 13.2854C30.4915 10.83 27.8742 7 22.0109 7Z",
    fill: "#F9525C",
    stroke: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0109 11C17.8682 11 13.7349 11.4217 13.1043 13.4269C13.0125 13.7185 13.2932 13.9567 13.5955 13.9112C19.4522 13.0299 24.565 13.0296 30.4212 13.9105C30.7252 13.9562 31.0063 13.7152 30.9116 13.4227C30.2629 11.4211 26.1507 11 22.0109 11Z",
    fill: "#FECE61",
    stroke: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15C19.3333 15 17.8 15.2 17 16",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15C24.6667 15 26.2 15.2 27 16",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 21.6C19.8 23.52 18.6 24 18 24C19.44 24 20.2 23.2 20.4 22.8C20.4 22.32 20.8 22.2 21 22.2H22.2V21H20.4C19.92 21 19.8 21.4 19.8 21.6Z",
    fill: "black",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21.6C24 23.52 25.2 24 25.8 24C24.36 24 23.6 23.2 23.4 22.8C23.4 22.32 23 22.2 22.8 22.2H21.6V21H23.4C23.88 21 24 21.4 24 21.6Z",
    fill: "black",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3596 24H21.6404C21.3151 24 21.0764 24.3057 21.1553 24.6213L21.5149 26.0597C21.6412 26.5647 22.3588 26.5647 22.4851 26.0597L22.8447 24.6213C22.9236 24.3057 22.6849 24 22.3596 24Z",
    fill: "#FF7E7A",
    stroke: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19C18.5 18.2454 19.8 17.1889 21 19",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19C23.5 18.2454 24.8 17.1889 26 19",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsyBody);
export default __webpack_public_path__ + "static/media/csy-body.80cfc3e66649743f6fcbfcf02b8b6cdd.svg";
export { ForwardRef as ReactComponent };